const MAX_SAFE_INTEGER = require('max-safe-integer'); //Mactrix line added - max-safe-integer ponyfill

const DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:".*?")|.*?)(?:,|$)/g;

// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class AttrList {

	constructor(attrs) {
		let myAttrs = attrs;

		if (typeof myAttrs === 'string') {
			myAttrs = AttrList.parseAttrList(myAttrs);
		}
		for(var attr in myAttrs) {
			if(myAttrs.hasOwnProperty(attr)) {
				this[attr] = myAttrs[attr];
			}
		}
	}

	decimalInteger(attrName) {
		const intValue = parseInt(this[attrName], 10);
	/* mactrix replace
	if (intValue > Number.MAX_SAFE_INTEGER) {
	*/
		if (intValue > MAX_SAFE_INTEGER) {		// Mactrix: SJE: Number.MAX_SAFE_INTEGER is not available on PhantomJS or IE
			return Infinity;
		}
		return intValue;
	}

	hexadecimalInteger(attrName) {
		if(this[attrName]) {
			let stringValue = (this[attrName] || '0x').slice(2);
			stringValue = ((stringValue.length & 1) ? '0' : '') + stringValue;

			const value = new Uint8Array(stringValue.length / 2);
			for (let i = 0; i < stringValue.length / 2; i++) {
				value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
			}
			return value;
		}
		else {
			return null;
		}
	}

	hexadecimalIntegerAsNumber(attrName) {
		const intValue = parseInt(this[attrName], 16);
	/* mactrix replace
	if (intValue > Number.MAX_SAFE_INTEGER) {
	*/
		if (intValue > MAX_SAFE_INTEGER) {	// Mactrix: SJE
			return Infinity;
		}
		return intValue;
	}

	decimalFloatingPoint(attrName) {
		return parseFloat(this[attrName]);
	}

	enumeratedString(attrName) {
		return this[attrName];
	}

	decimalResolution(attrName) {
		const res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
		if (res === null) {
			return undefined;
		}
		return {
			width: parseInt(res[1], 10),
			height: parseInt(res[2], 10),
		};
	}

	static parseAttrList(input) {
		let match;
		let attrs = {};
		let quote = '"';

		ATTR_LIST_REGEX.lastIndex = 0;
		while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {	// eslint-disable-line no-cond-assign
			var value = match[2];

			if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === (value.length - 1)) {
				value = value.slice(1, -1);
			}
			attrs[match[1]] = value;
		}

		return attrs;
	}

}

export default AttrList;



// WEBPACK FOOTER //
// ./src/hlsjs/utils/attr-list.js